import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as NavigationActions from './navigation.actions';
import * as NavigationSelectors from './navigation.selectors';

@Injectable({
  providedIn: 'root',
})
export class NavigationFacade {
  // Selectors
  currentProductUuid$: Observable<string | null>;
  currentCategory$: Observable<string | null>;
  isLoading$: Observable<boolean>;
  hasCurrentProduct$: Observable<boolean>;
  private store = inject(Store);

  constructor() {
    this.currentProductUuid$ = this.store.select(
      NavigationSelectors.selectCurrentProductUuid
    );

    this.currentCategory$ = this.store.select(
      NavigationSelectors.selectCurrentCategory
    );

    this.isLoading$ = this.store.select(
      NavigationSelectors.selectNavigationLoading
    );

    this.hasCurrentProduct$ = this.store.select(
      NavigationSelectors.selectHasCurrentProduct
    );
  }

  // Actions
  setCurrentProduct(productUuid: string, category: string): void {
    this.store.dispatch(NavigationActions.setCurrentProduct({ productUuid, category }));
  }

  clearCurrentProduct(): void {
    this.store.dispatch(NavigationActions.clearCurrentProduct());
  }

  setLoading(isLoading: boolean): void {
    this.store.dispatch(NavigationActions.setLoading({ isLoading }));
  }

  setCurrentCategory(category: string): void {
    this.store.dispatch(NavigationActions.setCurrentCategory({ category }));
  }

  clearCurrentCategory(): void {
    this.store.dispatch(NavigationActions.clearCurrentCategory());
  }
  }
